import { Injectable } from '@angular/core';
import { RegistroService } from 'src/app/registro.service';
import { ReporteGuardado } from 'src/interfaces/reporte-guardado.interface';

@Injectable({
    providedIn: 'root',
})
export class ReporteIndividualService {
    constructor(private registroService: RegistroService) {}

    existeRepoteGuardado() {
        const idReporteGuardado: any =
            this.registroService.listaReportesGuardados.find(
                (agenteVigilado) =>
                    agenteVigilado.idEmpresa ===
                    this.registroService.empresaSelected
            );
        if (idReporteGuardado) {
            return idReporteGuardado;
        }
        return;
    }

    //Actualiza o elimina el objeto del reporte guardado
    actualizarArregloReportes(respuestaDelServidor?) {
        const idEmpresaSeleccionada = this.registroService.empresaSelected;
        const indexReporteGuardado =
            this.registroService.listaReportesGuardados.findIndex(
                (agenteVigilado) =>
                    agenteVigilado.idEmpresa === idEmpresaSeleccionada
            );

        if (respuestaDelServidor) {
            if (indexReporteGuardado === -1) {
                const nuevoReporte: ReporteGuardado = {
                    idEmpresa: idEmpresaSeleccionada,
                    id_reporte_guardado: respuestaDelServidor.id,
                };
                this.registroService.listaReportesGuardados = [
                    ...this.registroService.listaReportesGuardados,
                    nuevoReporte,
                ];
            }
        } else if (indexReporteGuardado !== -1) {
            const nuevosReportes =
                this.registroService.listaReportesGuardados.filter(
                    (agenteVigilado) =>
                        agenteVigilado.idEmpresa !== idEmpresaSeleccionada
                );
            this.registroService.listaReportesGuardados = nuevosReportes;
        }
        return this.registroService.listaReportesGuardados;
    }
}
